import { render, staticRenderFns } from "./UserDisplayName.vue?vue&type=template&id=76e393b3"
import script from "./UserDisplayName.vue?vue&type=script&lang=js"
export * from "./UserDisplayName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports